'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('./utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function createState(_ref) {
  var ipns = _ref.ipns,
      options = _ref.options;
  var experimental = options.EXPERIMENTAL;

  function state() {
    return _state.apply(this, arguments);
  }

  function _state() {
    _state = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _options,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.prev = 1;
              return _context.abrupt("return", {
                enabled: Boolean(utils.getPubsubRouting(ipns, experimental))
              });

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", {
                enabled: false
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 5]]);
    }));
    return _state.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(state);
}

exports.createState = createState;